module.exports = __webpack_public_path__ + "static/img/service-h5-5.39dda87.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/service-h5-5.png
// module id = 4kTk
// module chunks = 34